module.exports = __webpack_public_path__ + "assets/img/wallpaper-os.d681bd91.jpg";